import React from "react";

// Plan-based feature gating is disabled by design. Every authenticated
// user gets access to every page regardless of subscriptionPlan / pro
// / enterprise. If we ever need to reintroduce paywalls, do it via the
// SA-managed `pageRoles` map on Organization instead — that keeps the
// access decision explicit and per-org rather than derived from a
// subscription enum in every user document.
const PlanProtectedRoute = ({ children }) => children;

export default PlanProtectedRoute;
